<div class="unlimited-access-description">
  Lejárat nélküli hozzáférés, pl. oktatóknak a termék bemutatásához. Független a csomagoktól és az előfizetéstől.
</div>

<div *ngFor="let option of accessOptions" class="unlimited-access-row">
  <mat-slide-toggle
    color="primary"
    [checked]="hasUnlimitedAccess(option.accessName)"
    [disabled]="!canModify || isSaving"
    (change)="onToggleChange(option, $event)"
  >
    {{ option.label }}
  </mat-slide-toggle>

  <span *ngIf="getUnlimitedAccess(option.accessName) as unlimitedAccess" class="unlimited-access-granted-info">
    Megadta: {{ unlimitedAccess.grantedByAdminEmail ?? unlimitedAccess.grantedByAdminUuid }},
    {{ unlimitedAccess.grantedTimestamp | date: "yyyy. MM. dd. HH:mm" }}
  </span>
</div>

<div *ngIf="!canModify" class="unlimited-access-no-permission">
  A módosításhoz ajándékozási jogosultság (STUDENT_GIFT_WRITE) szükséges.
</div>
